"use client";

import { c as _c } from "react/compiler-runtime";
import dynamic from "next/dynamic";
import React from "react";
import { prefetchSplitPanelsLayout } from "#/shared/ui/templates/SplitPanelsLayout/prefetchSplitPanelsLayout";
import type { SplitPanelsLayoutProps } from "#/shared/ui/templates/SplitPanelsLayout/SplitPanelsLayout";
const SplitPanelsLayout = dynamic(() => prefetchSplitPanelsLayout().then(module => ({
  default: module.SplitPanelsLayout
})), {
  ssr: false
});

/** Client-only split layout — avoids Emotion hydration mismatch without a mount gate. */
export const SplitPanelsLayoutClient: React.FC<SplitPanelsLayoutProps> = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <SplitPanelsLayout {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};